import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { DetailsRow } from "../../../../common/modal/details-rows/DetailsRow";
import { NaValue } from "../../../../common/modal/details-rows/NaValue";

type DurationRowProps = {
    activeDays?: number | null;
};

export const DurationRow = ({ activeDays }: DurationRowProps) => {
    const { translate } = useTranslate();

    return (
        <DetailsRow label={translate("activation.alerts.cards.display-ads.modal.duration")}>
            {activeDays != null ? (
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate("activation.alerts.cards.display-ads.modal.duration-days", {
                        count: activeDays,
                    })}
                </Text>
            ) : (
                <NaValue />
            )}
        </DetailsRow>
    );
};
